import React from 'react';
import Seo from '../components/Seo';
import ContactForm from '../components/ContactForm';
import './AuthPages.css';
import './Contact.css';

const MailIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);
const PhoneIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 13a19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 3.6 2h3a2 2 0 0 1 2 1.72c.127.96.361 1.903.7 2.81a2 2 0 0 1-.45 2.11L7.91 9.91a16 16 0 0 0 6.1 6.1l1.27-1.27a2 2 0 0 1 2.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0 1 22 16.92z"/>
  </svg>
);
const MapIcon = () => (
  <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const INFO = [
  { icon: <MailIcon />, label: 'Email us', value: 'info@invfly.com', href: 'mailto:info@invfly.com' },
  { icon: <PhoneIcon />, label: 'Call us', value: '+91 9381167479', href: 'tel:+919381167479' },
  { icon: <MapIcon />, label: 'Location', value: 'Hyderabad, Telangana, India', href: null },
];

const Contact = () => (
  <div className="auth-split contact-split">
    <Seo
      title="Contact — InvFly"
      description="Contact InvFly for stock market course enquiries, partnerships, and support. Email or WhatsApp us from Hyderabad."
    />

    {/* ── Brand pane ── */}
    <aside className="auth-split__brand">
      <div className="auth-split__brand-bg" aria-hidden="true" />

      <div className="auth-split__brand-body">
        <h1 className="auth-split__brand-title">
          Let's build something together.
        </h1>
        <p className="auth-split__brand-sub">
          Whether you have a course enquiry, want to partner with us, or just want to say hello — we're always happy to connect.
        </p>

        <ul className="auth-split__features">
          {INFO.map((item) => (
            <li key={item.label} className="auth-split__feature">
              <span className="auth-split__feature-icon" aria-hidden="true">{item.icon}</span>
              <div>
                <div className="auth-split__feature-title">{item.label}</div>
                {item.href ? (
                  <a
                    href={item.href}
                    className="auth-split__feature-desc"
                    target={item.href.startsWith('http') ? '_blank' : undefined}
                    rel="noopener noreferrer"
                    style={{ color: 'var(--text-2)', textDecoration: 'none' }}
                  >
                    {item.value}
                  </a>
                ) : (
                  <div className="auth-split__feature-desc">{item.value}</div>
                )}
              </div>
            </li>
          ))}
        </ul>

        <div style={{
          marginTop: 20,
          padding: '14px 18px',
          background: 'rgba(0,212,170,0.06)',
          border: '1px solid rgba(0,212,170,0.18)',
          borderRadius: 'var(--r)',
        }}>
          <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--text)', marginBottom: 5 }}>
            College &amp; University Partnerships
          </div>
          <p style={{ fontSize: 12, color: 'var(--text-2)', lineHeight: 1.6, margin: 0 }}>
            InvFly works as an industry education partner offering NEP 2020 aligned courses and seminars. Reach out to explore how we can collaborate.
          </p>
        </div>
      </div>

    
    </aside>

    {/* ── Form pane ── */}
    <main className="auth-split__form">
      <div className="auth-split__form-inner">
        <span className="auth-split__eyebrow">Get in touch</span>
        <h2 className="auth-split__title">Contact Us</h2>
        <p className="auth-split__subtitle">Fill in the form and we'll get back to you within one business day.</p>

        <ContactForm />
      </div>
    </main>
  </div>
);

export default Contact;
